<template>
  <admin-page-frame>
    <el-button size="mini" icon="el-icon-back" @click="$router.push('/admin/schools/student')">返回列表</el-button>
    <el-tabs v-model="activeTab" style="margin-top: 16px;">
      <el-tab-pane label="基本信息" name="info">
        <div v-loading="loading">
          <el-descriptions v-if="student.id" :column="2" border size="small">
            <el-descriptions-item label="学号">{{ student.studentCode }}</el-descriptions-item>
            <el-descriptions-item label="姓名">{{ student.studentName }}</el-descriptions-item>
            <el-descriptions-item label="性别">{{ genderLabel(student.gender) }}</el-descriptions-item>
            <el-descriptions-item label="家长手机">{{ student.parentPhone || '-' }}</el-descriptions-item>
            <el-descriptions-item label="状态">
              <el-tag :type="student.status === 1 ? 'success' : 'info'" size="mini">{{ student.status === 1 ? '正常' : '停用' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="备注" :span="2">{{ student.remark || '-' }}</el-descriptions-item>
          </el-descriptions>
        </div>
      </el-tab-pane>
      <el-tab-pane label="课时账户" name="account">
        <div v-loading="loading">
          <div style="margin-bottom: 12px;">
            <el-button type="primary" size="mini" icon="el-icon-plus" @click="openRecharge">课程充值</el-button>
          </div>
          <div v-if="summary.totalLessonRemain != null" class="schools-admin-page__stats" style="margin-bottom: 16px;">
            <div class="schools-admin-page__stat-card"><div class="label">剩余购买课时</div><div class="value">{{ summary.paidLessonRemain || 0 }}</div></div>
            <div class="schools-admin-page__stat-card"><div class="label">剩余赠送课时</div><div class="value">{{ summary.giftLessonRemain || 0 }}</div></div>
            <div class="schools-admin-page__stat-card"><div class="label">合计剩余</div><div class="value">{{ summary.totalLessonRemain || 0 }}</div></div>
          </div>
          <el-table :data="lessonAccounts" :border="false" size="small" style="width: 100%;" empty-text="暂无课时账户">
            <el-table-column prop="courseName" label="课程" min-width="120" show-overflow-tooltip />
            <el-table-column prop="className" label="班级" min-width="120" show-overflow-tooltip />
            <el-table-column prop="paidLessonRemain" label="购买剩余" width="100" align="center" />
            <el-table-column prop="giftLessonRemain" label="赠送剩余" width="100" align="center" />
            <el-table-column prop="expireDate" label="到期日" min-width="110" />
            <el-table-column label="状态" width="90" align="center">
              <template slot-scope="{ row }"><el-tag size="mini">{{ accountStatusLabel(row.status) }}</el-tag></template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="所在班级" name="classes">
        <div v-loading="loading">
          <div style="margin-bottom: 12px;">
            <el-button type="primary" size="mini" icon="el-icon-plus" @click="openAddClass">安排入班</el-button>
          </div>
          <el-table :data="classes" :border="false" size="small" style="width: 100%;" empty-text="暂未加入班级">
            <el-table-column prop="className" label="班级" min-width="140" />
            <el-table-column prop="classCode" label="编码" min-width="120" />
            <el-table-column prop="joinTime" label="入班时间" min-width="150" />
            <el-table-column label="操作" width="160" align="center">
              <template slot-scope="{ row }">
                <el-button type="text" size="mini" @click="$router.push('/admin/schools/class/' + row.classId)">班级详情</el-button>
                <el-button type="text" size="mini" class="admin-pc-table-actions__danger" @click="handleLeaveClass(row)">离班</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="课程课时充值" :visible.sync="rechargeVisible" width="520px" :close-on-click-modal="false" @closed="resetRecharge">
      <el-form ref="rechargeRef" :model="rechargeForm" :rules="rechargeRules" label-width="100px" size="small">
        <el-form-item label="课程" prop="courseId">
          <el-select v-model="rechargeForm.courseId" filterable placeholder="请选择课程" style="width: 100%;" @change="onCourseChange">
            <el-option v-for="c in courseOptions" :key="c.id" :label="c.courseName" :value="c.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="课包">
          <el-select v-model="rechargeForm.packageId" clearable filterable placeholder="可选，选后自动带出课时" style="width: 100%;" @change="onPackageChange">
            <el-option v-for="p in packageOptions" :key="p.id" :label="packageLabel(p)" :value="p.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="购买课时" prop="paidLessonCount">
          <el-input-number v-model="rechargeForm.paidLessonCount" :min="0" :max="9999" style="width: 100%;" />
        </el-form-item>
        <el-form-item label="赠送课时">
          <el-input-number v-model="rechargeForm.giftLessonCount" :min="0" :max="9999" style="width: 100%;" />
        </el-form-item>
        <el-form-item label="实收金额" prop="amount">
          <el-input-number v-model="rechargeForm.amount" :min="0" :precision="2" :step="100" style="width: 100%;" />
        </el-form-item>
        <el-form-item label="收款方式" prop="payChannel">
          <el-select v-model="rechargeForm.payChannel" style="width: 100%;">
            <el-option label="现金" value="cash" /><el-option label="转账" value="transfer" /><el-option label="POS" value="pos" />
          </el-select>
        </el-form-item>
        <el-form-item label="加入班级">
          <el-select v-model="rechargeForm.classId" clearable filterable placeholder="可选，充值后自动入班" style="width: 100%;">
            <el-option v-for="c in classOptionsForCourse" :key="c.id" :label="c.className" :value="c.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注"><el-input v-model="rechargeForm.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="rechargeVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="recharging" @click="submitRecharge">确认充值</el-button>
      </div>
    </el-dialog>

    <el-dialog title="安排入班" :visible.sync="addClassVisible" width="420px" :close-on-click-modal="false">
      <el-form label-width="80px" size="small">
        <el-form-item label="选择班级">
          <el-select v-model="addClassId" filterable placeholder="请选择班级" style="width: 100%;">
            <el-option v-for="c in classOptions" :key="c.id" :label="c.className" :value="c.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="addClassVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="addingClass" @click="submitAddClass">确定</el-button>
      </div>
    </el-dialog>
  </admin-page-frame>
</template>
<script>
import AdminPageFrame from './components/AdminPageFrame.vue'
import {
  addSchoolClassStudent,
  fetchSchoolClasses,
  fetchSchoolCourseDetail,
  fetchSchoolCourseOptions,
  fetchSchoolStudentDetail,
  rechargeSchoolStudentLesson,
  removeSchoolClassStudent
} from '@/api/h5-admin-schools'
import './schools-admin.less'

export default {
  name: 'SchoolsStudentDetail',
  components: { AdminPageFrame },
  data() {
    return {
      loading: false,
      recharging: false,
      addingClass: false,
      activeTab: 'info',
      student: {},
      lessonAccounts: [],
      summary: {},
      classes: [],
      courseOptions: [],
      packageOptions: [],
      classOptions: [],
      rechargeVisible: false,
      addClassVisible: false,
      addClassId: null,
      rechargeForm: {
        courseId: null,
        packageId: null,
        paidLessonCount: 0,
        giftLessonCount: 0,
        amount: 0,
        payChannel: 'cash',
        classId: null,
        remark: ''
      },
      rechargeRules: {
        courseId: [{ required: true, message: '请选择课程', trigger: 'change' }],
        paidLessonCount: [{ required: true, message: '请填写课时', trigger: 'change' }],
        amount: [{ required: true, message: '请填写金额', trigger: 'change' }],
        payChannel: [{ required: true, message: '请选择收款方式', trigger: 'change' }]
      }
    }
  },
  computed: {
    studentId() { return this.$route.params.id },
    classOptionsForCourse() {
      if (!this.rechargeForm.courseId) return this.classOptions
      return this.classOptions.filter(c => c.courseId === this.rechargeForm.courseId)
    }
  },
  created() {
    this.loadOptions()
    this.loadDetail()
  },
  methods: {
    loadOptions() {
      fetchSchoolCourseOptions().then(list => { this.courseOptions = list || [] })
      fetchSchoolClasses({ page: 0, size: 200 }).then(res => { this.classOptions = (res && res.content) || [] })
    },
    loadDetail() {
      this.loading = true
      fetchSchoolStudentDetail(this.studentId).then(res => {
        this.student = (res && res.student) || {}
        this.lessonAccounts = (res && res.lessonAccounts) || []
        this.summary = (res && res.lessonAccountSummary) || {}
        this.classes = (res && res.classes) || []
      }).finally(() => { this.loading = false })
    },
    genderLabel(v) { const map = { 0: '未知', 1: '男', 2: '女' }; return map[v] || '-' },
    accountStatusLabel(v) { const map = { active: '有效', frozen: '冻结', expired: '已过期' }; return map[v] || v || '-' },
    packageLabel(p) {
      return (p.packageName || '课包') + '（' + (p.lessonCount || 0) + '课时/' + (p.listPrice || 0) + '元）'
    },
    openRecharge() {
      this.rechargeVisible = true
    },
    resetRecharge() {
      this.packageOptions = []
      this.rechargeForm = { courseId: null, packageId: null, paidLessonCount: 0, giftLessonCount: 0, amount: 0, payChannel: 'cash', classId: null, remark: '' }
      this.$nextTick(() => this.$refs.rechargeRef && this.$refs.rechargeRef.clearValidate())
    },
    onCourseChange(courseId) {
      this.rechargeForm.packageId = null
      this.rechargeForm.classId = null
      this.packageOptions = []
      if (!courseId) return
      fetchSchoolCourseDetail(courseId).then(res => {
        this.packageOptions = (res && res.packages) || []
      })
    },
    onPackageChange(packageId) {
      const pkg = this.packageOptions.find(p => p.id === packageId)
      if (!pkg) return
      this.rechargeForm.paidLessonCount = pkg.lessonCount || 0
      this.rechargeForm.giftLessonCount = pkg.giftLessonCount || 0
      this.rechargeForm.amount = pkg.listPrice || 0
    },
    submitRecharge() {
      this.$refs.rechargeRef.validate(valid => {
        if (!valid) return
        if ((this.rechargeForm.paidLessonCount || 0) <= 0 && (this.rechargeForm.giftLessonCount || 0) <= 0) {
          this.$message.warning('购买或赠送课时至少填一项')
          return
        }
        this.$confirm('确认为该学员充值课时并登记收款？', '提示', { type: 'warning' }).then(() => {
          this.recharging = true
          rechargeSchoolStudentLesson(this.studentId, this.rechargeForm).then(() => {
            this.$message.success('充值成功')
            this.rechargeVisible = false
            this.loadDetail()
          }).finally(() => { this.recharging = false })
        }).catch(() => {})
      })
    },
    openAddClass() {
      this.addClassId = null
      this.addClassVisible = true
    },
    submitAddClass() {
      if (!this.addClassId) {
        this.$message.warning('请选择班级')
        return
      }
      this.addingClass = true
      addSchoolClassStudent(this.addClassId, this.studentId).then(() => {
        this.$message.success('已加入班级')
        this.addClassVisible = false
        this.loadDetail()
      }).finally(() => { this.addingClass = false })
    },
    handleLeaveClass(row) {
      this.$confirm('确认将该学员移出班级「' + row.className + '」？', '提示', { type: 'warning' }).then(() => {
        removeSchoolClassStudent(row.classId, this.studentId).then(() => {
          this.$message.success('已离班')
          this.loadDetail()
        })
      }).catch(() => {})
    }
  }
}
</script>
